"use client"

import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import OrgLayout from "@/layouts/OrgLayout"
import { CreditCard, Download, DollarSign } from "lucide-react"
import { useEffect } from "react"
import { createRefreshChannel } from "@/channels/refresh_channel"

type BillingProps = {
  page_count: number
  number_count: number
}
function Billing({ page_count, number_count }: BillingProps) {

  useEffect(() => {
    createRefreshChannel()
  }, [])


  return (
    <div className="space-y-6 w-full">
      <div>
        <h2 className="text-2xl font-semibold">Billing Settings</h2>
        <p className="text-sm text-muted-foreground">Manage billing information and payment methods</p>
      </div>

      <Card className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <DollarSign className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Current Month Spend</h3>
            <p className="text-sm text-muted-foreground">January 2025</p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Numbers ({number_count})</span>
            <span className="font-medium">${number_count.toFixed(2)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Fax Pages ({page_count})</span>
            <span className="font-medium">${(page_count * .06).toFixed(2)}</span>
          </div>
          <div className="flex items-center justify-between pt-2 border-t">
            <span className="font-semibold">Total</span>
            <span className="text-xl font-bold">${(number_count + page_count * .06).toFixed(2)}</span>
          </div>
        </div>
      </Card>

      {/*
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <CreditCard className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Payment Information</h3>
            <p className="text-sm text-muted-foreground">Update your billing details</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="card-number">Card Number</Label>
            <Input id="card-number" placeholder="**** **** **** 4242" />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="expiry">Expiry Date</Label>
              <Input id="expiry" placeholder="MM/YY" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="cvc">CVC</Label>
              <Input id="cvc" placeholder="123" />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="billing-email">Billing Email</Label>
            <Input id="billing-email" type="email" placeholder="billing@company.com" />
          </div>

          <div className="space-y-2">
            <Label htmlFor="billing-address">Billing Address</Label>
            <Input id="billing-address" placeholder="123 Main St, City, State 12345" />
          </div>

          <div className="flex justify-end pt-4">
            <Button>Update Payment Method</Button>
          </div>
        </div>
      </Card>
      */}

      {/*}
      <Card className="p-6">
        <h3 className="font-semibold mb-4">Current Plan</h3>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Professional Plan</p>
            <p className="text-sm text-muted-foreground">$99/month • Renews on Jan 15, 2025</p>
          </div>
          <Button variant="outline">Change Plan</Button>
        </div>
      </Card>
        */}

      {/*

        <Card className="p-6">
          <h3 className="font-semibold mb-4">Past Invoices</h3>
          <div className="space-y-2">
            {pastInvoices.map((invoice) => (
              <div key={invoice.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <p className="font-medium">{invoice.date}</p>
                  <p className="text-sm text-muted-foreground">{invoice.amount}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs px-2 py-1 bg-green-500/10 text-green-500 rounded-md">{invoice.status}</span>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </Card>

      */}
    </div>
  )
}
Billing.layout = (page: React.ReactNode) => <OrgLayout activeSection="billing">{page}</OrgLayout>
export default Billing
